import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type { PA_PMS_RATE_REFRESH_TYPE } from 'lumen/utils/constants/pricing-assistant-constants';

type PricingAssistantRateRefreshType =
  (typeof PA_PMS_RATE_REFRESH_TYPE)[keyof typeof PA_PMS_RATE_REFRESH_TYPE];

export default class PaPmsInfo extends Model {
  [Type] = 'pa-pms-info' as const;

  @attr('dayjs') declare pricingAssistantLastRateRefresh: DayjsTransformReturn;
  @attr('string')
  declare pricingAssistantRateRefreshType: PricingAssistantRateRefreshType;
  // Also used as id (primaryKey in the model serializer)
  @attr('number') declare subscriptionId: number;
}
